import useMutation from "src/hooks/useMutation";

function useTPUpdate(id) {
  return useMutation({
    path: `/api/v1/shipping-providers/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/shipping-providers`,
      shouldRevalidate: true,
    },
  });
}

export default useTPUpdate;
